import hydraConfig from '../config/hydra';

/**
 * Only some regions/countries are required to comply to GDPR
 * @returns {boolean}
 */
export function isEprivacyStorageRequired() {
  return !!hydraConfig.eprivacy_scope;
}
